import React from 'react';
import Toolbar from '@mui/material/Toolbar';
import PropTypes from 'prop-types';

const MobileHeader = props => {
  const { button } = props;
  return (
    <Toolbar
      disableGutters
      sx={{
        boxShadow: 1,
        zIndex: 2,
      }}
      variant="dense"
    >
      {button}
    </Toolbar>
  );
};

MobileHeader.propTypes = {
  button: PropTypes.node.isRequired,
};

export default MobileHeader;
